@use '@/styles/tokens' as *;

/* `<MapOverlay>` puts its box's top-left at the projected pixel, so a handle needs the same
 * centring correction `marked-points.module.scss`'s `.stack` makes for a **Point** — reduced to
 * plain centring here, because a handle has no tooltip column above it to lay out. */
.center {
  position: absolute;
  transform: translate(-50%, -50%);
}

/* Figma `598:539874`–`598:539877` are literal 5×5 squares — far too small to grab — so the visible
 * glyph stays 5px while the <button> is padded out to a 16px hit area: the "small visual, generous
 * hit target" idiom `<CloseButton>` already uses.
 *
 * 5px and the 1px corner are written RAW, the same call `marked-points.module.scss` makes for its
 * 21px circle: the smallest radius token is 4px, nothing on the space scale is 5px, and snapping
 * either would change the glyph's shape rather than its spacing. */
.handle {
  @include reset-button;
  @include focus-ring;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  /* The gesture on offer here is resizing, not marking — so not the canvas's `crosshair`, and not
   * a **Point**'s `grab`. */
  cursor: nwse-resize;
  /* <MapOverlay>'s container takes no pointer events and an interactive child opts back in. */
  pointer-events: auto;

  &::after {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 1px;
    background: var(--surface-card);
  }
}
